export class WebhookV1AuditEvent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1AuditEventTypeEnum",
            "format": ""
        },
        {
            "name": "payload",
            "baseName": "payload",
            "type": "any",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1AuditEvent.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1AuditEventTypeEnum;
(function (WebhookV1AuditEventTypeEnum) {
    WebhookV1AuditEventTypeEnum["AuditLogCreated"] = "AUDIT_LOG_CREATED";
})(WebhookV1AuditEventTypeEnum || (WebhookV1AuditEventTypeEnum = {}));
